import React from 'react';
import { Provider } from 'react-redux';
import PropTypes from 'prop-types';
import { SiteSettingsModal } from '../components/SiteSettingsModal';

export const SiteSettingsModalProvider = ({ store }) => {
    return (
        <Provider store={store}>
            <SiteSettingsModal />
        </Provider>
    );
};

SiteSettingsModalProvider.propTypes = {
    store: PropTypes.object.isRequired
};
